import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Ciudad from './Ciudad.js';

class Ciudades extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'ciudad/filter', deleteUrl: 'ciudad/delete', deleteField: 'ciudad_nombre', modUrl: '/Catalogo/Ciudad' },
      TableOp.Table('Ciudades', [
        { label: 'Ciudad', id: 'ciudad' },
        // { label: 'Ciudad', id: 'ciudad_nombre' },
        { label: 'Estado', id: 'estado' },
      ], [
      ])
    );
    this.table();
  }

  render() {
    return (
      <div>
        <div>
          {
             
          <Ciudad   onSave={() => { this.table() }}></Ciudad>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(Ciudades);